import React from 'react'
import { Field } from 'redux-form/immutable'

import RadioButtonUniversal from 'app/components/RadioButtonUniversal'
import EnabledOrDisabledSquare from './EnabledOrDisabledSquare'
// @ts-ignore
import { required } from 'helpers/validators'
import { IOptionScaleStepProps } from './interface'
import './styles.scss'

export const NOT_APPLICABLE = '-1'
const isRequired = required()
const bc = 'option-scale-step'

const OptionScaleStep: React.FC<IOptionScaleStepProps> = ({
  scale = ['0', '1', '2', '3', '4'],
  name,
  nextStep,
  change,
  getFormValue,
}) => {
  const currentValue = getFormValue(name)
  return (
    <div className={`${bc}__wrapper`}>
      <RadioButtonUniversal
        input={{
          onChange: () => {
            change(name, NOT_APPLICABLE)
          },
          checked: currentValue === NOT_APPLICABLE,
        }}
        enabledComponent={<EnabledOrDisabledSquare value={NOT_APPLICABLE} enabled />}
        disabledComponent={<EnabledOrDisabledSquare value={NOT_APPLICABLE} />}
        customAction={nextStep}
        className={`${bc}__radio-button-universal__na`}
        key={`option-scale-step_${NOT_APPLICABLE}`}
      />
      <div className={`${bc}__vertical-line`} />
      <div className={`${bc}__options-wrapper`}>
        <div className={`${bc}__options`}>
          {scale.map(value => {
            const enabledComponent = <EnabledOrDisabledSquare value={value} enabled />
            const disabledComponent = <EnabledOrDisabledSquare value={value} />
            return (
              <Field
                key={`option-scale-step_${value}`}
                type="radio"
                name={name}
                component={RadioButtonUniversal}
                enabledComponent={enabledComponent}
                disabledComponent={disabledComponent}
                value={value}
                customAction={nextStep}
                className={`${bc}__radio-button-universal`}
                validate={[isRequired]}
              />
            )
          })}
        </div>
        <div className={`${bc}__anchors`}>
          <div>Strongly disagree</div>
          <div>Strongly agree</div>
        </div>
      </div>
    </div>
  )
}

export default OptionScaleStep
